import { atom, useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { LOCALE_DE, LOCALE_EN, PRODUCT_TYPES } from '@config/app.constants';

/**
 * Global State managed by Jotai. To use this module please read ./store.md
 */

/**
 * Language
 */
const language = atom<typeof LOCALE_DE | typeof LOCALE_EN>(LOCALE_DE);

export const useLanguageStore = () => useAtom(language);

/**
 * Number of briefings for the current user
 */
const numberOfBriefings = atom(0);

export const useNumberOfBriefingsStore = () => useAtom(numberOfBriefings);

/**
 * Product Type
 * https://jotai.org/docs/utils/atom-with-storage
 */
const productType = atomWithStorage<PRODUCT_TYPES>(
  'product_type',
  PRODUCT_TYPES.shortlist,
);

export const useProductTypeStore = () => useAtom(productType);

/**
 * Product Tab Selected
 */
const productTabSelected = atom<PRODUCT_TYPES>(null as PRODUCT_TYPES);

export const useProductTabSelectedStore = () => useAtom(productTabSelected);

/**
 * Whether the user has seen the Onlyfy onboarding dialog.
 */
const seenOnlyfyOnboarding = atomWithStorage('seenOnlyfyOnboarding', false);

export const useOnlyfyOnboardingStore = () => useAtom(seenOnlyfyOnboarding);
